import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-39c87068")

_pushScopeId("data-v-39c87068")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 患者登録メニュー ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新規登録")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("仮登録の患者様")
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("を本登録")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("一括登録")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("お客様が")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("自分の端末で入力")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("(入力用コード発行)")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("お客様情報")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("着信一覧")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_badge_frame = _resolveComponent("badge-frame")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode("div", {
        class: ["button-row", _ctx.$mq]
      }, [
        _createVNode(_component_normal_button, {
          class: "menu-button",
          state: "normal-green",
          large: true,
          onClick: _ctx.registerPatient
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_normal_button, {
          class: "menu-button",
          state: "normal",
          large: true,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/temporary_patient_list`)))
        }, {
          default: _withId(() => [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_normal_button, {
          class: "menu-button",
          state: "normal",
          large: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/bulk_register_patient`)))
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ], 2),
      _createVNode("div", {
        class: ["button-row", _ctx.$mq]
      }, [
        _createVNode(_component_normal_button, {
          class: "menu-button",
          state: "warning",
          large: true,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/register_patient_qr`)))
        }, {
          default: _withId(() => [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_badge_frame, {
          count: _ctx.patientAnswers.length
        }, {
          default: _withId(() => [
            _createVNode(_component_normal_button, {
              class: "menu-button",
              state: "normal",
              large: true,
              disabled: _ctx.patientAnswers.length===0,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/patient_answer`)))
            }, {
              default: _withId(() => [
                _hoisted_12,
                _hoisted_13,
                _hoisted_14
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["count"])
      ], 2)
    ]),
    _: 1
  }))
})